var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "833.000000pt",
    height: "173.000000pt",
    viewBox: "0 0 833.000000 173.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,173.000000) scale(0.100000,-0.100000)",
    fill: "#19467B",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2960 850 c0 -507 3 -770 10 -770 7 0 10 263 10 770 0 507 -3 770 -10 770 -7 0 -10 -263 -10 -770z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3482 1463 c4 -179 17 -218 84 -270 63 -48 192 -44 259 9 55 43 68 89 73 261 l5 157 -66 0 -65 0 -3 -143 c-3 -115 -8 -148 -22 -170 -37 -57 -107 -40 -126 30 -6 21 -11 93 -11 161 l0 122 -66 0 -66 0 4 -157z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4560 1390 l0 -230 65 0 64 0 3 106 3 106 85 -106 85 -106 52 0 53 0 0 230 0 230 -65 0 -64 0 -3 -110 -3 -110 -85 110 -85 109 -52 1 -53 0 0 -230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5780 1390 l0 -230 65 0 65 0 0 230 0 230 -65 0 -65 0 0 -230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 1536 c-3 -8 -4 -213 -2 -457 4 -421 5 -448 26 -523 55 -198 157 -329 315 -406 70 -34 106 -44 200 -57 105 -15 123 -15 227 0 91 13 129 24 197 58 155 74 262 209 314 394 22 77 23 98 26 543 l4 462 -200 0 -201 0 0 -374 c0 -208 -5 -409 -11 -453 -27 -200 -140 -305 -294 -273 -111 23 -177 122 -195 291 -5 52 -10 255 -10 452 l0 357 -195 0 c-158 0 -197 -3 -201 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1660 825 l0 -725 205 0 206 0 -3 265 -3 265 243 0 242 0 0 165 0 165 -240 0 -240 0 0 115 0 115 295 0 295 0 0 180 0 180 -500 0 -500 0 0 -725z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3550 380 l0 -230 65 0 65 0 0 85 0 85 75 0 75 0 0 50 0 50 -75 0 -75 0 0 35 0 34 88 3 87 3 3 58 3 57 -156 0 -155 0 0 -230z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4670 589 c-92 -42 -134 -107 -134 -209 0 -138 93 -230 232 -230 187 0 293 216 181 370 -59 82 -184 112 -279 69z m164 -130 c20 -24 26 -41 26 -81 0 -44 -4 -54 -34 -84 -38 -38 -69 -43 -106 -17 -32 21 -38 30 -49 71 -12 40 1 87 31 119 34 36 98 32 132 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5660 380 l0 -230 65 0 65 0 0 71 c0 67 1 70 22 67 15 -2 34 -24 61 -70 l39 -68 75 0 75 0 -32 53 c-65 109 -66 112 -41 142 47 61 48 139 2 203 -36 50 -75 62 -210 62 l-121 0 0 -230z m228 77 c5 -39 -14 -57 -59 -57 l-39 0 0 46 0 45 48 -3 c43 -3 47 -5 50 -31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6710 472 c0 -163 14 -222 62 -269 43 -41 76 -53 146 -53 77 1 133 27 169 81 27 42 28 45 31 211 l4 169 -64 -3 -63 -3 -5 -148 c-5 -148 -5 -149 -33 -173 -35 -30 -49 -30 -84 0 l-28 24 -3 151 -3 151 -65 0 -64 0 0 -138z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7760 380 l0 -230 65 0 65 0 0 108 1 107 32 -72 c31 -71 33 -73 68 -73 35 0 37 2 72 78 l36 77 1 -112 0 -113 65 0 65 0 0 230 0 230 -71 0 -70 0 -48 -102 -49 -103 -48 103 -47 102 -69 0 -68 0 0 -230z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74ea1d0e0a9184aab16f667740fc350b.svg";
export { ForwardRef as ReactComponent };